import './header';
import './scrolling-list';
import './product-comparison';
import './product-overview';
import './slideshow';
import './products';
import './scroll-position';

import Nav from './nav';

window.addEventListener('DOMContentLoaded', () => {
	const header = document.querySelector<HTMLElement>('.page-header');
	const button = document.querySelector<HTMLElement>('#nav-toggle');
	const nav = document.querySelector<HTMLElement>('.primary-nav');

	if (!header || !button || !nav) {
		return;
	}

	new Nav({
		header,
		button,
		nav,
	});
});

document.querySelectorAll('.submenu').forEach(submenu => {
	if (submenu.scrollWidth > submenu.clientWidth) {
		const current = submenu.querySelector<HTMLElement>(
			'a[aria-current="page"]',
		);
		if (!current) return;
		submenu.scrollTo(current.offsetLeft - 40, 0);
	}
});

document.querySelectorAll('[data-scroll-down]').forEach(el => {
	el.addEventListener('click', () => {
		window.scrollBy({
			left: 0,
			top: window.innerHeight / 2,
			behavior: 'smooth',
		});
	});
});
